// Filled (solid) header glyphs — ServiceAI parity.
//
// ServiceAI's app-bar icons read as solid silhouettes, whereas the stock
// @progress/kendo-svg-icons glyphs are thin outline-style paths (e.g. the
// inbox is drawn as a hollow tray). The Kendo set ships no solid variants and
// we can't add an icon dependency, so we keep each icon's *meaning* but supply
// a filled path. These are plain `SVGIcon` objects, so they drop straight into
// the same `<SvgIcon icon={...} />` the rest of the header already uses.
//
// Geometry is Material-style (viewBox "0 0 24 24", nonzero fill — inner
// counters render as holes). currentColor inheritance is handled by SvgIcon.
import type { SVGIcon } from '@progress/kendo-svg-icons';

const VIEW_BOX = '0 0 24 24';

/** Settings — solid cog with a hollow centre. */
export const gearFilledIcon: SVGIcon = {
  name: 'gear-filled',
  viewBox: VIEW_BOX,
  content:
    '<path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>',
};

/** Getting Started — solid play triangle. */
export const playFilledIcon: SVGIcon = {
  name: 'play-filled',
  viewBox: VIEW_BOX,
  content: '<path d="M8 5v14l11-7z"/>',
};

/** Action Required — solid inbox tray (kept as an inbox per the design call). */
export const inboxFilledIcon: SVGIcon = {
  name: 'inbox-filled',
  viewBox: VIEW_BOX,
  content:
    '<path d="M19 3H4.99C3.88 3 3.01 3.9 3.01 5L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"/>',
};

/** What's New — solid notification bell. */
export const bellFilledIcon: SVGIcon = {
  name: 'bell-filled',
  viewBox: VIEW_BOX,
  content:
    '<path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>',
};
